import { useContext } from "react";
import { useCompositionsContext } from "features/compositions/context/CompositionsContext";

export const useCalcDropCompProgress = () => {
    const singleCompDuration = 3;

    const { databaseStructure } = useCompositionsContext();
    const total = (databaseStructure?.compositions?.length || 0);

    return (((total) * singleCompDuration * 1000) / 100);
}

export const useCalcCreateCompProgress = () => {
    const singleCompDuration = 2;

    const { databaseStructure } = useCompositionsContext();
    const total = (databaseStructure?.compositions?.length || 0) + 1;

    return (((total) * singleCompDuration * 1000) / 100)
}